import React, {useState, useEffect, useRef} from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CardContent} from '@material-ui/core';
import axios from '../../api';
import '../../App.css'
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';
import 'datatables.net/js/jquery.dataTables';
import Swal from "sweetalert2";
import VisualizarPacientes from "../Actions/VisualizarPacientes";


const columns = [{id: 'name', label: 'Nome ', width: '20%'}, {id: 'cpf', label: 'CPF', width: '10%'}, {
    id: 'idade',
    label: 'Idade',
    width: '2%'
}, {id: 'cns', label: 'CNS', width: '10%'}, {id: 'preferencial', label: 'Prioridade', width: '10%'}, {
    id: 'created_at',
    label: 'Data cadastro',
    width: '10%'
}, {id: 'situacao_paciente', label: 'Situação', width: '2%'}, {id: 'acoes', label: 'Ações', width: '20%'},];

function TabelaPacientes() {
    const [results, setTableData] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {

        Swal.fire({
            title: 'Carregando...', allowEscapeKey: false, allowOutsideClick: false, didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get('/paciente', {timeout: 5000})
            .then(response => {
                const results = response.data.data;
                setTableData(results);

                // Verifique se o DataTable já foi inicializado na tabela
                const table = $('#paciente').DataTable();
                if ($.fn.DataTable.isDataTable('#paciente')) {
                    table.destroy();
                }

                // Inicialize o DataTable aqui
                $(document).ready(function () {
                    $('#paciente').DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                        }, deferRender: true, destroy: true, // adicione essa opção
                        autoWidth: false, columnDefs: [{
                            targets: ['_all'], className: 'mdc-data-table__cell',
                        },],
                    });
                });
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                Swal.close();
            });
    }, []);

    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [results]);

    return (

        <TableContainer component={Paper}>
            <CardContent>
                <Table id="paciente" className={'table compact'} ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (<TableCell id={"header"} style={{width: column.width}}
                                                                 key={column.id}>{column.label}</TableCell>))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((result) => (<TableRow key={result.id}>
                                <TableCell>{result.name}</TableCell>
                                <TableCell>{result.cpf}</TableCell>
                                <TableCell>{result.idade}</TableCell>
                                <TableCell>{result.cns}</TableCell>
                                <TableCell>{result.preferencial}</TableCell>
                                <TableCell>{result.created_at}</TableCell>
                            <TableCell>
<small
    className={`status ${result.status === 0 ? 'status--red' : 'status--green'}`}
>
    {/* Exibe o que estará escrito dentro do badge */}
    {result.status === 0 ? 'Aguardando atendimento' : 'Atendimento concluído'}
  </small>
                            </TableCell>

                            <TableCell>
                                    <VisualizarPacientes
                                        id={Number(result.id)}
                                        title="Detalhes do pacientes"
                                        apiUrl={`https://gerenciamentoatendimento.cloud/api/paciente/`}
                                    />

                                </TableCell>

                            </TableRow>))}
                    </TableBody>
                </Table>
            </CardContent>
        </TableContainer>

    );
}

export default TabelaPacientes;
